import React, { FC, ReactElement } from "react";
import { ButtonProps } from "@mui/material";

import { StyledWrapper, StyledMuiButton, StyledMuiSvgIcon } from "./styled";

export interface IToolbarButton extends ButtonProps {
  viewBox?: string;
  icon?: ReactElement;
  active?: boolean;
  iconWidth?: number;
  iconHeight?: number;
}

export const ToolbarButton: FC<IToolbarButton> = props => {
  const { children, icon, viewBox, active = false, iconWidth, iconHeight, ...rest } = props;

  return (
    <StyledWrapper sx={{ background: active ? "#363846" : "inherit", height: 36 }}>
      <StyledMuiButton {...rest} color="inherit">
        {icon ? (
          <StyledMuiSvgIcon viewBox={viewBox} sx={{ width: iconWidth, height: iconHeight }}>
            {icon}
          </StyledMuiSvgIcon>
        ) : (
          children
        )}
      </StyledMuiButton>
    </StyledWrapper>
  );
};
